import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import '@fortawesome/fontawesome-free/css/all.css';
import NotyfPlugin from './plugins/notyf'; // if you created a plugin wrapper
import branding_plugin from './plugins/branding_plugin';
import branding_service from './services/branding_service';


// ... (keep your imports at the top)

const app = createApp(App);
app.use(router);
app.use(NotyfPlugin);
app.use(branding_plugin);

// Initialize branding on route changes
router.beforeEach(async (to, from, next) => {
  if (!branding_service.initialized) {
    try {
      const user_details = localStorage.getItem('user');
      if (user_details) {
        const user = JSON.parse(user_details);
        const org_id = user?.company_id || user?.organization_id;
        if (org_id) {
          await branding_service.load_branding(org_id);
        }
      }
    } catch (error) {
      console.error('[Branding] Failed to load:', error);
    }
  }
  next();
});

/**
 * This function now returns the object and handles
 * the data-client attribute properly.
 */
export function get_domain_style() {
  const domain = process.env.VUE_APP_DOMAIN;

  if (domain) {
    document.documentElement.setAttribute('data-client', domain);
  }

  // Default values
  let styleConfig = {
    name: 'pulsecheck',
    style: import('@/views/home.css'),
    login_page_logo: require('@/assets/dwypd_logo/pulse_check.png'),
    title: 'PULSE CHECK',
    powered_by_name: 'PULSE CHECK',
    logo: require('@/assets/dwypd_logo/pulse_check.png'),
    favicon: require('@/assets/dwypd_logo/pulse_check_icon.png'),
    reset_logo: require('@/assets/dwypd_logo/pulse_check.png'),
    //Sidebar Icons images
    collapse_vector_sidebar: require('@/assets/sidebar_toggle.svg'),
    settings_vector_sidebar: require('@/assets/setting.svg'),
    profile_vector_sidebar: require('@/assets/profile.svg'),
    users_vector_sidebar: require('@/assets/user.svg'),
    workspace_vector_sidebar: require('@/assets/empty-wallet.svg'),
    permissions_vector_sidebar: require('@/assets/permission.svg'),
    audit_vector_sidebar: require('@/assets/safearea.svg'),
    app_vector: require('@/assets/aicone_platforms.svg'),
    notification_vector: require('@/assets/Notification.svg'),

    //Apps icons images
    allowed_apps: ['proba', 'complyon_onboard', 'complyon'],
    complyon_icon: require('@/assets/platforms_icons/complyon.svg'),
    complyon_onboard_icon: require('@/assets/platforms_icons/Onboardid.png'),
    engagenet_icon: require('@/assets/platforms_icons/engagenet.svg'),
    proba_icon: require('@/assets/platforms_icons/proba-analytics.svg'),
    workflows_icon: require('@/assets/platforms_icons/proba-workflows.svg'),
    orcaa_icon: require('@/assets/platforms_icons/orcaa_ai.svg'),
    xverdict_icon: require('@/assets/platforms_icons/x-verdict.svg'),
  };

  if (domain.includes('rematholdings')) {
    styleConfig = {
      ...styleConfig,
      name: 'rematholdings',
      style: import('@/views/home.css'),
      title: 'Remat Holdings',
      powered_by_name: 'Remat Holdings',
      login_page_logo: require('@/assets/remat_holdings/remat_logo.png'),
      logo: require('@/assets/remat_holdings/remat_logo.png'),
      favicon: require('@/assets/remat_holdings/remat_logo.png'),
      reset_logo: require('@/assets/remat_holdings/remat_logo.png'),
      //Sidebar Icons images
      settings_vector_sidebar: require('@/assets/remat_holdings/settings_vector.svg'),
      profile_vector_sidebar: require('@/assets/remat_holdings/profile_vector.svg'),
      users_vector_sidebar: require('@/assets/remat_holdings/users_vector.svg'),
      workspace_vector_sidebar: require('@/assets/remat_holdings/workspace_vector.svg'),
      permissions_vector_sidebar: require('@/assets/remat_holdings/permissions_vector.svg'),
      audit_vector_sidebar: require('@/assets/remat_holdings/audit_vector.svg'),
      app_vector: require('@/assets/remat_holdings/app_vector.svg'),
      notification_vector: require('@/assets/remat_holdings/notification_vector.svg'),

      //Apps icons images
      allowed_apps: ['orcaa','workflow','engagenet','x-verdict','proba','complyon'],
      complyon_icon: require('@/assets/platforms_icons/complyon.svg'),
      engagenet_icon: require('@/assets/platforms_icons/engagenet.svg'),
      proba_icon: require('@/assets/platforms_icons/proba-analytics.svg'),
      workflows_icon: require('@/assets/platforms_icons/proba-workflows.svg'),
      orcaa_icon: require('@/assets/platforms_icons/orcaa_ai.svg'),
      xverdict_icon: require('@/assets/platforms_icons/x-verdict.svg'),
    };
  }

  if (domain.includes('datacheck')) {
    styleConfig = {
      ...styleConfig,
      name: 'datacheck',
      style: import('@/views/home.css'),
      title: 'Data Check',
      powered_by_name: 'Data Check',
      login_page_logo: require('@/assets/datacheck/datacheck_logo.svg'),
      logo: require('@/assets/datacheck/datacheck_logo.svg'),
      favicon: require('@/assets/datacheck/favicon.svg'),
      reset_logo: require('@/assets/datacheck/logo.svg'),
      //Sidebar Icons images
      collapse_vector_sidebar: require('@/assets/sidebar_toggle.svg'),
      settings_vector_sidebar: require('@/assets/setting.svg'),
      profile_vector_sidebar: require('@/assets/profile.svg'),
      users_vector_sidebar: require('@/assets/user.svg'),
      workspace_vector_sidebar: require('@/assets/empty-wallet.svg'),
      permissions_vector_sidebar: require('@/assets/permission.svg'),
      audit_vector_sidebar: require('@/assets/safearea.svg'),
      app_vector: require('@/assets/aicone_platforms.svg'),
      notification_vector: require('@/assets/Notification.svg'),

      //Apps icons images
      allowed_apps: ['proba','complyon'],
      complyon_icon: require('@/assets/datacheck/complyon_icon.svg'),
      engagenet_icon: require('@/assets/platforms_icons/engagenet.svg'),
      proba_icon: require('@/assets/datacheck/proba_analytics_icon.svg'),
      workflows_icon: require('@/assets/platforms_icons/proba-workflows.svg'),
      orcaa_icon: require('@/assets/platforms_icons/orcaa_ai.svg'),
      xverdict_icon: require('@/assets/platforms_icons/x-verdict.svg'),
    };
  }

  if (domain.includes('apex')) {
    styleConfig = {
      ...styleConfig,
      name: 'apex',
      style: import('@/views/home.css'),
      title: 'APEX SOLVE',
      powered_by_name: 'APEX',
      login_page_logo: require('@/assets/apex/apex_login_logo.png'),
      logo: require('@/assets/apex/apex_logo.png'),
      favicon: require('@/assets/apex/apex_color_favicon.svg'),
      reset_logo: require('@/assets/apex/apex_login_logo.png'),
      //Sidebar Icons images
      collapse_vector_sidebar: require('@/assets/sidebar_toggle.svg'),
      settings_vector_sidebar: require('@/assets/setting.svg'),
      profile_vector_sidebar: require('@/assets/profile.svg'),
      users_vector_sidebar: require('@/assets/user.svg'),
      workspace_vector_sidebar: require('@/assets/empty-wallet.svg'),
      permissions_vector_sidebar: require('@/assets/permission.svg'),
      audit_vector_sidebar: require('@/assets/safearea.svg'),
      app_vector: require('@/assets/aicone_platforms.svg'),
      notification_vector: require('@/assets/Notification.svg'),

      //Apps icons images
      allowed_apps: ['engagenet','proba','complyon'],
      complyon_icon: require('@/assets/apex/apex_intakes.svg'),
      engagenet_icon: require('@/assets/apex/engage.svg'),
      proba_icon: require('@/assets/apex/data.svg'),
      workflows_icon: require('@/assets/platforms_icons/proba-workflows.svg'),
      orcaa_icon: require('@/assets/platforms_icons/orcaa_ai.svg'),
      xverdict_icon: require('@/assets/platforms_icons/x-verdict.svg'),
    };
  }

  if (domain.includes('absa')) {
    styleConfig = {
      ...styleConfig,
      name: 'absa',
      style: import('@/views/home.css'),
      title: 'ABSA',
      powered_by_name: 'AI CAMPUS',
      login_page_logo: require('@/assets/absa/absa_color_logo.svg'),
      logo: require('@/assets/absa/absa_color_logo.svg'),
      favicon: require('@/assets/absa/absa_color_favicon.png'),
      reset_logo: require('@/assets/absa/absa_color_logo.svg'),
      //Sidebar Icons images
      collapse_vector_sidebar: require('@/assets/sidebar_toggle.svg'),
      settings_vector_sidebar: require('@/assets/setting.svg'),
      profile_vector_sidebar: require('@/assets/profile.svg'),
      users_vector_sidebar: require('@/assets/user.svg'),
      workspace_vector_sidebar: require('@/assets/empty-wallet.svg'),
      permissions_vector_sidebar: require('@/assets/permission.svg'),
      audit_vector_sidebar: require('@/assets/safearea.svg'),
      app_vector: require('@/assets/aicone_platforms.svg'),
      notification_vector: require('@/assets/Notification.svg'),

      //Apps icons images
      allowed_apps: ['proba','complyon'],
      complyon_icon: require('@/assets/platforms_icons/complyon.svg'),
      engagenet_icon: require('@/assets/apex/engage.svg'),
      proba_icon: require('@/assets/platforms_icons/proba-analytics.svg'),
      workflows_icon: require('@/assets/platforms_icons/proba-workflows.svg'),
      orcaa_icon: require('@/assets/platforms_icons/orcaa_ai.svg'),
      xverdict_icon: require('@/assets/platforms_icons/x-verdict.svg'),
    };
  }

// --- START INJECTION BLOCK ---

  // 1. Inject the Page Title
  document.title = styleConfig.title;

  // 2. Inject the Favicon
  // This looks for <link rel="icon"> or <link rel="shortcut icon">
  let favicon = document.querySelector('link[rel="icon"]') ||
                document.querySelector('link[rel="shortcut icon"]');

  if (favicon) {
    favicon.href = styleConfig.favicon;
  } else {
    // If for some reason the tag is missing, create it
    const new_link = document.createElement('link');
    new_link.rel = 'icon';
    new_link.href = styleConfig.favicon;
    document.head.appendChild(new_link);
  }

  // 3. Inject the Apple Touch Icon (optional, for mobile)
  let apple_icon = document.querySelector('link[rel="apple-touch-icon"]');
  if (apple_icon) {
    apple_icon.href = styleConfig.favicon;
  }

  return styleConfig;
}

// Call the function so it executes
const currentStyle = get_domain_style();
app.config.globalProperties.$domainStyle = currentStyle;

app.mount('#app');
export default app;